// NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
if (typeof window === 'undefined') {
    const exports = {};
    object(
        exports,
        require('lodash'),
        require('backbone')
    );

    module.exports = exports.Object;
} else {
    object(
        RivalIQ,
        window._,
        window.Backbone
    );
}

function object(base, _, Backbone) {
    'use strict';

    // A RivalIQ namespaced base object similar to Marionette.Object
    // Defined ourselves so we can avoid Marionette as a server side dependency
    base.Object = function (options) {
        const me = this;
        me.options = _.extend({}, _.result(me, 'options'), options);

        me.initialize.apply(me, arguments);
    };

    base.Object.extend = Backbone.Model.extend;

    // Backbone.Events mixed in for Backbone.Collection lifecycle
    _.extend(base.Object.prototype, Backbone.Events, {
        initialize: function () {}
    });
}
